import axios from "../../config/axiosConfig";
import {
  CREATE_JOB_WORK_ISSUE, DELETE_JOB_WORK_ISSUE,
  GET_JOB_WORK_ISSUE,
  JOB_WORK_ISSUE_REQUEST,
  JOB_WORK_ISSUE_REQUEST_FAILURE,
  UPDATE_JOB_WORK_ISSUE,
  GET_JOB_WORK_ISSUES_PAGE,
  JOB_WORK_ISSUE_REQUEST_SUCCESS,
  GET_JOB_WORK_ISSUE_AVAILABLE_TRANSACTIONS,
  JOB_WORK_ISSUE_TRANSACTION_AVAILABLE_REQUEST,
  JOB_WORK_ISSUE_TRANSACTION_AVAILABLE_REQUEST_FAILURE
} from "../types/job-work-issue-types";


export const getJobWorkIssuesWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_WORK_ISSUE_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Account_Id,Job_Id'
      };
      return axios.get("/job-work-issue/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_JOB_WORK_ISSUES_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_WORK_ISSUE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_WORK_ISSUE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getJobWorkIssueById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_WORK_ISSUE_REQUEST });
    
      return axios.get(`/job-work-issue/get/${id}`).then((response) => {
        dispatch({ type: JOB_WORK_ISSUE_REQUEST_SUCCESS });
        return response?.data?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_WORK_ISSUE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_WORK_ISSUE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getJobWorkIssueBeamDetail = (beamNo) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_WORK_ISSUE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id, Beam_No: beamNo };
      return axios.get(`/job-work-issue/getBeamDetail`, { params }).then((response) => {
        dispatch({ type: JOB_WORK_ISSUE_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_WORK_ISSUE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_WORK_ISSUE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getJobWorkIssuesByRange = (billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        billId, from, to
      };
      
      const response = await axios.get("/job-work-issue/getAll", { params });
      return response?.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getJobWorkIssue = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_WORK_ISSUE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/job-work-issue/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_JOB_WORK_ISSUE, payload: response?.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_WORK_ISSUE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_WORK_ISSUE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createJobWorkIssue = (jobWorkIssue) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: JOB_WORK_ISSUE_REQUEST });
      const newJobWorkIssue = {
        ...jobWorkIssue
      };
      return axios.post("/job-work-issue/add", newJobWorkIssue,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_JOB_WORK_ISSUE, payload: response.data });
        } else {
          dispatch({
            type: JOB_WORK_ISSUE_REQUEST_FAILURE,
            error: "Job Work Issue create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_WORK_ISSUE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_WORK_ISSUE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateJobWorkIssue = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_WORK_ISSUE_REQUEST });
      const { auth } = getState();
      return axios.put("/job-work-issue/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }}
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_JOB_WORK_ISSUE,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: JOB_WORK_ISSUE_REQUEST_FAILURE,
            error: "Job Work Issue update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_WORK_ISSUE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_WORK_ISSUE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteJobWorkIssue = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_WORK_ISSUE_REQUEST });
      return axios.delete(`/job-work-issue/delete/${id}`).then((response) => {
        if (response.data) {
          const include = ['id', 'Vch_No', 'Date', 'Account_Id', 'Job_Id', 'Lot_Id', 'Design_Id', 'LR_Transporter_Id'].join(',');
          const searchCols = ['Vch_No'].join(',');
          const { currentPage, pageSize, searchStr, where} = getState()?.inventory?.jobWorkIssue || {};
          dispatch(getJobWorkIssuesWithPagination(currentPage, pageSize, include, searchStr, searchCols, where, true));
          dispatch({ type: DELETE_JOB_WORK_ISSUE, id: id });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_WORK_ISSUE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_WORK_ISSUE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getJobWorkIssueAvailableTransactions = (queryParams) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_WORK_ISSUE_TRANSACTION_AVAILABLE_REQUEST });
      const { auth } = getState();
      let params = { ...queryParams, customerId: auth?.user?.Customer_Id };
      
      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/job-work-issue/getAvailableIssues", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_JOB_WORK_ISSUE_AVAILABLE_TRANSACTIONS, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_WORK_ISSUE_TRANSACTION_AVAILABLE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_WORK_ISSUE_TRANSACTION_AVAILABLE_REQUEST_FAILURE, error: error.message });
    }
  };
};